import { toYMD, formatDateTime } from "../../../../common/helpers/time";
function InstructorRequestTimeOffDayController(
  UserService,
  $state,
  UsersModel,
  TimeoffRequestsModel,
  FlashService,
) {
  const vm = this;
  vm.date = new Date();
  vm.currentUser = UserService.getCurrentUser();
  vm.requestDayOff = {};

  vm.requestType = {
    dayOff: false,
    moreThanDay: false,
    partialDay: false,
  };

  vm.requestDayOff = {};

  vm.submitDayRequest = submitDayRequest;
  vm.updateDayOffDate = updateDayOffDate;
  vm.updateFromTime = updateFromTime;
  vm.updateToTime = updateToTime;

  init();

  function init() {
    //set initial value for time pickers
    vm.requestDayOff.from = new Date();
    vm.requestDayOff.from.setHours(9);
    vm.requestDayOff.from.setMinutes(0);
    vm.requestDayOff.to = new Date();
    vm.requestDayOff.to.setHours(12);
    vm.requestDayOff.to.setMinutes(0);
  }

  function updateDayOffDate(newDate) {
    vm.requestDayOff.date = newDate.selected[0];
  }

  function updateFromTime(newTime) {
    vm.requestDayOff.from = newTime.selected[0];
  }

  function updateToTime(newTime) {
    vm.requestDayOff.to = newTime.selected[0];
  }

  function partialDayTimesAreInvalid() {
    const fromMinutes =
      vm.requestDayOff.from.getHours() * 60 +
      vm.requestDayOff.from.getMinutes();
    const toMinutes =
      vm.requestDayOff.to.getHours() * 60 + vm.requestDayOff.to.getMinutes();
    return toMinutes <= fromMinutes;
  }

  function submitDayRequest(isValid) {
    vm.submitted = true;
    if (isValid) {
      if (vm.requestType.partialDay === true && partialDayTimesAreInvalid()) {
        FlashService.setMessage({
          type: "error",
          message: "The end time must be after the start time.",
        });
        return;
      }

      if (vm.requestType.partialDay === false) {
        //if its a full day request, set start and end time
        vm.requestDayOff.from = new Date();
        vm.requestDayOff.from.setHours(0);
        vm.requestDayOff.from.setMinutes(0);

        vm.requestDayOff.to = new Date();
        vm.requestDayOff.to.setHours(23);
        vm.requestDayOff.to.setMinutes(59);
      }

      const dateStr = toYMD(vm.requestDayOff.date);
      const fromTime =
        vm.requestDayOff.from.getHours() +
        ":" +
        vm.requestDayOff.from.getMinutes().toString().padStart(2, "0");
      const toTime =
        vm.requestDayOff.to.getHours() +
        ":" +
        vm.requestDayOff.to.getMinutes().toString().padStart(2, "0");
      const beginString = dateStr + " " + fromTime;
      const endString = dateStr + " " + toTime;
      const begin = new Date(beginString);
      const end = new Date(endString);

      const request = {
        user_id: vm.currentUser.id,
        begin: formatDateTime(begin, "YYYY-MM-DD HH:mm:ss"),
        end: formatDateTime(end, "YYYY-MM-DD HH:mm:ss"),
        type: vm.requestType.partialDay ? "partial" : "full",
        status: "Pending",
        reason: vm.requestDayOff.reason,
      };

      TimeoffRequestsModel.create(request).then((response) => {
        FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        vm.submitted = false;
        $state.go("drivecoach.instructor.dashboard");
      });
    } else {
      FlashService.setMessage({
        type: "error",
        message: "Please fill the form.",
      });
    }
  }
}
InstructorRequestTimeOffDayController.$inject = [
  "UserService",
  "$state",
  "UsersModel",
  "TimeoffRequestsModel",
  "FlashService",
];
export default InstructorRequestTimeOffDayController;
